/* eslint-disable max-len */
import React from 'react';
function Profile() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10S17.5,2,12,2z M18.4,16.8c-1.4-1.7-4.9-2.3-6.4-2.3s-4.9,0.6-6.4,2.3 c-1-1.3-1.6-3-1.6-4.8c0-4.4,3.6-8,8-8s8,3.6,8,8C20,13.8,19.4,15.5,18.4,16.8z M12,6c-1.9,0-3.5,1.6-3.5,3.5S10.1,13,12,13 s3.5-1.6,3.5-3.5S13.9,6,12,6z" })));
}
export default Profile;
